<template>
    <div v-if="chartData">
        <div id="enterprise-hw-type" style="width:1680px; height:558px;"></div>
    </div>
    <div v-else>
        <div style="line-height:500px">暂无数据</div>
    </div>
</template>

<script>
/* eslint-disable */

import * as echarts from "echarts";
import EventBus from "../js/event-bus";

export default {
    name: "EnterpriseHwType",
    data() {
        return {
            chartData: null,
        };
    },
    mounted() {
        EventBus.$on("showOrganizationDetail", (organizationId) => {
            if (!organizationId) {
                return;
            }
            this.getManufactureYearly(organizationId);
        });
    },
    methods: {
        getManufactureYearly(organizationId) {
            this.$api
                .getManufactureYearly(organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.chartData = result.data;
                        setTimeout(() => {
                            this.drawLine();
                        }, 500);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        drawLine() {
            echarts
                .init(document.getElementById("enterprise-hw-type"))
                .dispose(); // 销毁实例
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(
                document.getElementById("enterprise-hw-type")
            );
            var yearLabel = ["hwClass"];
            while (this.chartData.beginYear < this.chartData.endYear) {
                yearLabel.push(this.chartData.beginYear.toString());
                this.chartData.beginYear++;
            }
            yearLabel.push(this.chartData.endYear.toString());

            var source = [yearLabel];
            var series = [];

            this.chartData.data.forEach((x) => {
                var item = [];
                item.push(x.hwCode1 + "(" + x.hwName1 + ")");
                item = item.concat(x.total);
                source.push(item);
                series.push({
                    type: "line",
                    smooth: true,
                    seriesLayoutBy: "row",
                    emphasis: { focus: "series" },
                });
            });

            series.push({
                type: "pie",
                id: "pie",
                radius: "30%",
                center: ["50%", "25%"],
                emphasis: { focus: "data" },
                label: {
                    formatter: "{b}: {@" + this.chartData.endYear + "} ({d}%)",
                    normal: {
                        textStyle: {
                            color: "#cce2fc", // 改变标示文字的颜色
                        },
                    },
                },
                encode: {
                    itemName: "hwClass",
                    value: this.chartData.endYear.toString(),
                    tooltip: this.chartData.endYear.toString(),
                },
            });

            // 绘制图表
            myChart.setOption({
                legend: {
                    textStyle: {
                        color: "#cce2fc",
                    },
                    orient: "vertical",
                    left: "right",
                },
                tooltip: {
                    trigger: "axis",
                    showContent: false,
                },
                dataset: {
                    source: source,
                },
                xAxis: {
                    type: "category",
                    axisLabel: {
                        //修改坐标系字体颜色
                        show: true,
                        textStyle: {
                            color: "#8DB6DB",
                        },
                    },
                },
                yAxis: {
                    gridIndex: 0,
                    axisLabel: {
                        //修改坐标系字体颜色
                        show: true,
                        textStyle: {
                            color: "#8DB6DB",
                        },
                    },
                },
                grid: { top: "55%" },
                series: series,
            });

            myChart.on("updateAxisPointer", function (event) {
                var xAxisInfo = event.axesInfo[0];
                if (xAxisInfo) {
                    var dimension = xAxisInfo.value + 1;
                    myChart.setOption({
                        series: {
                            id: "pie",
                            label: {
                                formatter: "{b}: {@[" + dimension + "]} ({d}%)",
                            },
                            encode: {
                                value: dimension,
                                tooltip: dimension,
                            },
                        },
                    });
                }
            });
        },
    },
};
</script>

<style lang="less"></style>
